export const logoStyles = {
  width: '220px',
  height: '30px',
  marginTop: '5px'
};

